import { DropdownItem as BSDropdownItem } from 'reactstrap';

import styles from './Dropdown.module.scss';

export const DropdownItem = ({ children, onClick }: { children: React.ReactNode; onClick?: () => void }) => {
  return (
    <BSDropdownItem cssModule={styles} onClick={onClick}>
      {children}
    </BSDropdownItem>
  );
};
